/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("da", {
  Redo: "Gendan",
  Undo: "Fortryd",
  Cut: "Klip",
  Copy: "Kopier",
  Paste: "S\u00e6t ind",
  "Select all": "V\u00e6lg alle",
  "New document": "Nyt dokument",
  Ok: "Ok",
  Cancel: "Annuller",
  "Visual aids": "Visuel hj\u00e6lp",
  Bold: "Fed",
  Italic: "Kursiv",
  Underline: "Understreget",
  Strikethrough: "Gennemstreget",
  Superscript: "H\u00e6vet skrift",
  Subscript: "S\u00e6nket skrift",
  "Clear formatting": "Nulstil formattering",
  "Align left": "Opstil til venstre",
  "Align center": "Centrer",
  "Align right": "Opstil til h\u00f8jre",
  Justify: "Justering",
  "Bullet list": "Punktopstillet liste",
  "Numbered list": "Nummereret liste",
  "Decrease indent": "Formindsk indrykning",
  "Increase indent": "For\u00f8g indrykning",
  Close: "Luk",
  Formats: "Formater",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Din browser underst\u00f8tter ikke direkte adgang til udklipsholder. Benyt Ctrl+X/C/ tastaturgenveje i stedet for.",
  Headers: "Overskrifter",
  "Header 1": "Overskrift 1",
  "Header 2": "Overskrift 2",
  "Header 3": "Overskrift 3",
  "Header 4": "Overskrift 4",
  "Header 5": "Overskrift 5",
  "Header 6": "Overskrift 6",
  Headings: "Overskrifter",
  "Heading 1": "Overskrift 1",
  "Heading 2": "Overskrift 2",
  "Heading 3": "Overskrift 3",
  "Heading 4": "Overskrift 4",
  "Heading 5": "Overskrift 5",
  "Heading 6": "Overskrift 6",
  Preformatted: "Forudformateret",
  Div: "Div",
  Pre: "Pre",
  Code: "Kode",
  Paragraph: "Afsnit",
  Blockquote: "Blockquote",
  Inline: "Inline",
  Blocks: "Blokke",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "S\u00e6t ind er indstillet til at inds\u00e6tte som ren tekst. Indhold bliver nu indsat uden formatering indtil du \u00e6ndrer indstillingen.",
  Fonts: "Skrifttyper",
  "Font Sizes": "Skriftst\u00f8rrelse",
  Class: "Class",
  "Browse for an image": "S\u00f8g efter et billede",
  OR: "OR",
  "Drop an image here": "Slip et billede her",
  Upload: "Upload",
  Block: "Blok\u00e9r",
  Align: "Align",
  Default: "Standard",
  Circle: "Cirkel",
  Disc: "Disk",
  Square: "Kvadrat",
  "Lower Alpha": "Lower Alpha",
  "Lower Greek": "Lower Gr\u00e6sk",
  "Lower Roman": "Lower Roman",
  "Upper Alpha": "Upper Alpha",
  "Upper Roman": "Upper Roman",
  "Anchor...": "Anker...",
  Name: "Navn",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Id b\u00f8r starte med et bogstav, efterfulgt af bogstaver, tal, bindestreger, punktummer, koloner eller underscores.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Du har ikke gemte \u00e6ndringer. Er du sikker p\u00e5 at du vil forts\u00e6tte?",
  "Restore last draft": "Genopret sidste kladde",
  "Special character...": "Specielle tegn...",
  "Source code": "Kildekode",
  "Insert/Edit code sample": "Inds\u00e6t/Ret kodeeksempel",
  Language: "Sprog",
  "Code sample...": "Kodeeksempel...",
  "Color Picker": "Farvev\u00e6lger",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "Venstre til h\u00f8jre",
  "Right to left": "H\u00f8jre til venstre",
  "Emoticons...": "Emotikoner...",
  "Metadata and Document Properties": "Metadata og dokumentegenskaber",
  Title: "Titel",
  Keywords: "S\u00f8geord",
  Description: "Beskrivelse",
  Robots: "Robotter",
  Author: "Forfatter",
  Encoding: "Kodning",
  Fullscreen: "Fuldsk\u00e6rm",
  Action: "Handling",
  Shortcut: "Genvej",
  Help: "Hj\u00e6lp",
  Address: "Adresse",
  "Focus to menubar": "Fokus p\u00e5 menulinjen",
  "Focus to toolbar": "Fokus p\u00e5 v\u00e6rkt\u00f8jslinjen",
  "Focus to element path": "Fokuser p\u00e5 elementvej",
  "Focus to contextual toolbar":
    "Fokuser p\u00e5 kontekstuelle v\u00e6rkt\u00f8jslinje",
  "Insert link (if link plugin activated)":
    "Inds\u00e6t link (hvis link plugin er aktiveret)",
  "Save (if save plugin activated)": "Gem (hvis save plugin er aktiveret)",
  "Find (if searchreplace plugin activated)":
    "Find (hvis searchreplace plugin er aktiveret)",
  "Plugins installed ({0}):": "Installerede plugins ({0}):",
  "Premium plugins:": "Premium plugins:",
  "Learn more...": "L\u00e6r mere...",
  "You are using {0}": "Du benytter {0}",
  Plugins: "Plugins",
  "Handy Shortcuts": "Praktiske Genveje",
  "Horizontal line": "Vandret linie",
  "Insert/edit image": "Inds\u00e6t/ret billede",
  "Image description": "Billede beskrivelse",
  Source: "Kilde",
  Dimensions: "Dimensioner",
  "Constrain proportions": "Behold propertioner",
  General: "Generet",
  Advanced: "Avanceret",
  Style: "Stil",
  "Vertical space": "Lodret afstand",
  "Horizontal space": "Vandret afstand",
  Border: "Kant",
  "Insert image": "Inds\u00e6t billede",
  "Image...": "Billede...",
  "Image list": "Billede liste",
  "Rotate counterclockwise": "Drej modsat urets retning",
  "Rotate clockwise": "Drej med urets retning",
  "Flip vertically": "Flip vertikalt",
  "Flip horizontally": "Flip horisontalt",
  "Edit image": "Rediger billede",
  "Image options": "Billede indstillinger",
  "Zoom in": "Zoom ind",
  "Zoom out": "Zoom ud",
  Crop: "Besk\u00e6r",
  Resize: "Skaler",
  Orientation: "Retning",
  Brightness: "Lysstyrke",
  Sharpen: "G\u00f8r skarpere",
  Contrast: "Kontrast",
  "Color levels": "Farve niveauer",
  Gamma: "Gamma",
  Invert: "Inverter",
  Apply: "Anvend",
  Back: "Tilbage",
  "Insert date/time": "Inds\u00e6t dato/klokkeslet",
  "Date/time": "Dato/klokkeslet",
  "Insert/Edit Link": "Inds\u00e6t/rediger link",
  "Insert/edit link": "Inds\u00e6t/ret link",
  "Text to display": "Vis tekst",
  Url: "Url",
  "Open link in...": "\u00c5bn link med...",
  "Current window": "Aktuelle vindue",
  None: "Ingen",
  "New window": "Nyt vindue",
  "Remove link": "Fjern link",
  Anchors: "Ankre",
  "Link...": "Link...",
  "Paste or type a link": "Inds\u00e6t eller skriv et link",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "URLen som du angav ser ud til at v\u00e6re en email adresse. \u00d8nsker du at tilf\u00f8je det kr\u00e6vede prefiks  mailto: ?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "URLen som du angav ser ud til at v\u00e6re et eksternt link. \u00d8nsker du at tilf\u00f8je det kr\u00e6vede prefiks http:// ?",
  "Link list": "Link liste",
  "Insert video": "Inds\u00e6t video",
  "Insert/edit video": "Inds\u00e6t/ret video",
  "Insert/edit media": "Inds\u00e6t/ret medier",
  "Alternative source": "Alternativ kilde",
  "Alternative source URL": "Alternativ kilde URL",
  "Media poster (Image URL)": "Medieplakat (billede URL)",
  "Paste your embed code below:": "Inds\u00e6t din embed kode herunder:",
  Embed: "Integrer",
  "Media...": "Medie...",
  "Nonbreaking space": "H\u00e5rdt mellemrum",
  "Page break": "Sideskift",
  "Paste as text": "Inds\u00e6t som ren tekst",
  Preview: "Forh\u00e5ndsvisning",
  "Print...": "Udskriv...",
  Save: "Gem",
  Find: "Find",
  "Replace with": "Erstat med",
  Replace: "Erstat",
  "Replace all": "Erstat alt",
  Previous: "Forrige",
  Next: "N\u00e6ste",
  "Find and replace...": "Find og erstat...",
  "Could not find the specified string.": "Kunne ikke finde s\u00f8getekst",
  "Match case": "STORE og sm\u00e5 bogstaver",
  "Find whole words only": "Find kun hele ord",
  "Spell check": "Stavekontrol",
  Ignore: "Ignorer",
  "Ignore all": "Ignorer alt",
  Finish: "F\u00e6rdig",
  "Add to Dictionary": "Tilf\u00f8j til ordbog",
  "Insert table": "Inds\u00e6t tabel",
  "Table properties": "Tabel egenskaber",
  "Delete table": "Slet tabel",
  Cell: "Celle",
  Row: "R\u00e6kke",
  Column: "Kolonne",
  "Cell properties": "Celle egenskaber",
  "Merge cells": "Flet celler",
  "Split cell": "Split celle",
  "Insert row before": "Inds\u00e6t r\u00e6kke f\u00f8r",
  "Insert row after": "Inds\u00e6t r\u00e6kke efter",
  "Delete row": "Slet r\u00e6kke",
  "Row properties": "R\u00e6kke egenskaber",
  "Cut row": "Klip r\u00e6kke",
  "Copy row": "Kopier r\u00e6kke",
  "Paste row before": "Inds\u00e6t r\u00e6kke f\u00f8r",
  "Paste row after": "Inds\u00e6t r\u00e6kke efter",
  "Insert column before": "Inds\u00e6t kolonne f\u00f8r",
  "Insert column after": "Inds\u00e6t kolonne efter",
  "Delete column": "Slet kolonne",
  Cols: "Kolonne",
  Rows: "R\u00e6kker",
  Width: "Bredde",
  Height: "H\u00f8jde",
  "Cell spacing": "Celle afstand",
  "Cell padding": "Celle padding",
  "Show caption": "Vis overskrift",
  Left: "Venstre",
  Center: "Centrering",
  Right: "H\u00f8jre",
  "Cell type": "Celle type",
  Scope: "Anvendelsesomr\u00e5de",
  Alignment: "Tilpasning",
  "H Align": "H juster",
  "V Align": "V juster",
  Top: "Top",
  Middle: "Midt",
  Bottom: "Bund",
  "Header cell": "Sidehoved celle",
  "Row group": "R\u00e6kke gruppe",
  "Column group": "Kolonne gruppe",
  "Row type": "R\u00e6kke type",
  Header: "Sidehoved",
  Body: "Krop",
  Footer: "Sidefod",
  "Border color": "Kant farve",
  "Insert template...": "Inds\u00e6t skabelon...",
  Templates: "Skabeloner",
  Template: "Skabelon",
  "Text color": "Tekst farve",
  "Background color": "Baggrunds farve",
  "Custom...": "Brugerdefineret...",
  "Custom color": "Brugerdefineret farve",
  "No color": "Ingen farve",
  "Remove color": "Fjern farve",
  "Table of Contents": "Indholdsfortegnelse",
  "Show blocks": "Vis klokke",
  "Show invisible characters": "Vis usynlige tegn",
  "Word count": "Optalte ord",
  Count: "Antal",
  Document: "Dokument",
  Selection: "Valg",
  Words: "Ord",
  "Words: {0}": "Ord: {0}",
  "{0} words": "{0} ord",
  File: "Fil",
  Edit: "Rediger",
  Insert: "Inds\u00e6t",
  View: "Vis",
  Format: "Format",
  Table: "Tabel",
  Tools: "V\u00e6rkt\u00f8j",
  "Powered by {0}": "Drevet af {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Rich Text omr\u00e5de. Tryk ALT-F9 for menu. Tryk ALT-F10 for toolbar. Tryk ALT-0 for hj\u00e6lp",
  "Image title": "Billedtitel",
  "Border width": "Kantbredde",
  "Border style": "Kantstil",
  Error: "Fejl",
  Warn: "Advar",
  Valid: "Gyldig",
  "To open the popup, press Shift+Enter":
    "Tryk skift + enter for at \u00e5bne pop op",
  "Rich Text Area. Press ALT-0 for help.":
    "Rich tekst omr\u00e5de. Tryk p\u00e5 ALT-0 for hj\u00e6lp.",
  "System Font": "Systemskrifttype",
  "Failed to upload image: {0}": "Mislykket billed-upload:",
  "Failed to load plugin: {0} from url {1}":
    "Mislykket plugin indl\u00e6sning: {0}  fra url {1}",
  "Failed to load plugin url: {0}":
    "Mislykket indl\u00e6sning af plugin-url: {0}",
  "Failed to initialize plugin: {0}": "Mislykket initiering a plugin: {0}",
  example: "eksempel",
  Search: "S\u00f8g",
  All: "Alle",
  Currency: "Valuta",
  Text: "Tekst",
  Quotations: "Anf\u00f8rselstegn",
  Mathematical: "Matematiske tegn",
  "Extended Latin": "Udvidet Latin",
  Symbols: "Symboler",
  Arrows: "Pile",
  "User Defined": "Brugerdefineret",
  "dollar sign": "dollartegn",
  "currency sign": "valutategn",
  "euro-currency sign": "euro-tegn",
  "colon sign": "kolontegn",
  "cruzeiro sign": "cruzeiro-tegn",
  "french franc sign": "fransk frank-tegn",
  "lira sign": "lira-tegn",
  "mill sign": "mill-tegn",
  "naira sign": "naira-tegn",
  "peseta sign": "peseta-tegn",
  "rupee sign": "rupee-tegn",
  "won sign": "won-tegn",
  "new sheqel sign": "ny sheqel-tegn",
  "dong sign": "dong-tegn",
  "kip sign": "kip-tegn",
  "tugrik sign": "tugrik-tegn",
  "drachma sign": "drakmer-tegn",
  "german penny symbol": "tysk penny-symbol",
  "peso sign": "peso-tegn",
  "guarani sign": "guarani-tegn",
  "austral sign": "austral-tegn",
  "hryvnia sign": "hryvnia-tegn",
  "cedi sign": "cedi-tegn",
  "livre tournois sign": "livre tournois-tegn",
  "spesmilo sign": "spesmilo-tegn",
  "tenge sign": "tenge-tegn",
  "indian rupee sign": "indisk rupee-tegn",
  "turkish lira sign": "tyrkisk lira-tegn",
  "nordic mark sign": "nordisk mark-tegn",
  "manat sign": "manat-tegn",
  "ruble sign": "rubel-tegn",
  "yen character": "yen-tegn",
  "yuan character": "yuan-tegn",
  "yuan character, in hong kong and taiwan": "yuan-tegn, i hong kong og taiwan",
  "yen/yuan character variant one": "yen/yuan-tegn variant en",
  "Loading emoticons...": "Indl\u00e6ser emotikoner...",
  "Could not load emoticons": "Kunne ikke indl\u00e6se emotikoner",
  People: "Folk",
  "Animals and Nature": "Dyr og natur",
  "Food and Drink": "F\u00f8de og drikke",
  Activity: "Aktivitet",
  "Travel and Places": "Rejser og steder",
  Objects: "Objekter",
  Flags: "Flag",
  Characters: "Tegn",
  "Characters (no spaces)": "Tegn (uden mellemrum)",
  "{0} characters": "{0} tegn",
  "Error: Form submit field collision.": "Fejl: Form submit felt kollision",
  "Error: No form element found.": "Fejl: Ingen form element fundet.",
  Update: "Opdater",
  "Color swatch": "Farvepr\u00f8ve",
  Turquoise: "Turkis",
  Green: "Gr\u00f8n",
  Blue: "Bl\u00e5",
  Purple: "Lilla",
  "Navy Blue": "Marinebl\u00e5",
  "Dark Turquoise": "M\u00f8rketurkis",
  "Dark Green": "M\u00f8rkegr\u00f8n",
  "Medium Blue": "Medium bl\u00e5",
  "Medium Purple": "Medium lilla",
  "Midnight Blue": "Midnatsbl\u00e5",
  Yellow: "Gul",
  Orange: "Orange",
  Red: "R\u00f8d",
  "Light Gray": "Lysegr\u00e5",
  Gray: "Gr\u00e5",
  "Dark Yellow": "M\u00f8rkegul",
  "Dark Orange": "M\u00f8rkeorange",
  "Dark Red": "M\u00f8rker\u00f8d",
  "Medium Gray": "Mellemgr\u00e5",
  "Dark Gray": "M\u00f8rkegr\u00e5",
  "Light Green": "Lysegr\u00f8n",
  "Light Yellow": "Lysegul",
  "Light Red": "Lyser\u00f8d",
  "Light Purple": "Lyslilla",
  "Light Blue": "Lysebl\u00e5",
  "Dark Purple": "M\u00f8rkelilla",
  "Dark Blue": "M\u00f8rkebl\u00e5",
  Black: "Sort",
  White: "Hvid",
  "Switch to or from fullscreen mode":
    "Skift til eller fra fuldsk\u00e6rmstilstand",
  "Open help dialog": "\u00c5bn hj\u00e6lpedialog",
  history: "historie",
  styles: "stile",
  formatting: "formatering",
  alignment: "justering",
  indentation: "indrykning",
  "permanent pen": "permanent pen",
  comments: "kommentarer",
  "Format Painter": "Formatpensel",
  "Insert/edit iframe": "Inds\u00e6t/rediger iframe",
  Capitalization: "Store bogstaver",
  lowercase: "sm\u00e5 bogstaver",
  UPPERCASE: "STORE BOGSTAVER",
  "Title Case": "Stort begyndelsesbogstav",
  "Permanent Pen Properties": "Permanente penegenskaber",
  "Permanent pen properties...": "Permanente penegenskaber...",
  Font: "Skrifttype",
  Size: "St\u00f8rrelse",
  "More...": "Mere...",
  "Spellcheck Language": "Sprog til stavekontrol",
  "Select...": "V\u00e6lg...",
  Preferences: "Pr\u00e6ferencer",
  Yes: "Ja",
  No: "Nej",
  "Keyboard Navigation": "Navigation med tastatur",
  Version: "Version",
  Anchor: "Anchor",
  "Special character": "Specielle tegn",
  "Code sample": "Kodepr\u00f8ve",
  Color: "Farve",
  Emoticons: "Emot-ikoner",
  "Document properties": "Dokument egenskaber",
  Image: "Billede",
  "Insert link": "Inds\u00e6t link",
  Target: "Target",
  Link: "Link",
  Poster: "Poster",
  Media: "Medier",
  Print: "Udskriv",
  Prev: "Forrige",
  "Find and replace": "Find og erstat",
  "Whole words": "Hele ord",
  Spellcheck: "Stavekontrol",
  Caption: "Tekst",
  "Insert template": "Inds\u00e6t skabelon",
});
